import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Modal, ProgressBar } from 'react-bootstrap';
import { IoCloudUpload, IoSquareOutline, IoTabletLandscapeOutline, IoTabletPortraitOutline, IoAdd, IoCheckmarkCircle } from "react-icons/io5";
import HeaderMenu from './Header';
import './index.css';
import Masonry from 'react-masonry-css';
import { generate, pay } from './Backend';
import { FaImage } from 'react-icons/fa';
import { getAccount, getAccountData, getDesignsForAccount, saveDesign, deductFromAccountBalance } from './Utils/get';
import OnboardingModal from './Onboarding';

const GeneratorPage = () => {
  const imageBannerPrice = 0.2;

  const [isPageLoading, setIsPageLoading] = useState(true);
  const [prompt, setPrompt] = useState('');
  const [imagePrompt, setImagePrompt] = useState('');
  const [aspectRatio, setAspectRatio] = useState('1:1');
  const [numberOfImages, setNumberOfImages] = useState(1);
  const [bannerStyle, setBannerStyle] = useState('');
  const [accountId, setAccountId] = useState(null);
  const [userDesigns, setUserDesigns] = useState([]);
  const [balance, setBalance] = useState(0);
  const [showAddBalanceModal, setShowAddBalanceModal] = useState(false);
  const [selectedAmount, setSelectedAmount] = useState(null);
  const [customAmount, setCustomAmount] = useState('');
  const [currentTime, setCurrentTime] = useState(Date.now());
  const [paymentLinkLoading, setPaymentLinkLoading] = useState(false);
  const [isGenerating, setIsGenerating] = useState(false);
  const [showOnboarding, setShowOnboarding] = useState(false);

  useEffect(() => {
    const hideOnboarding = localStorage.getItem('hideOnboarding');
    if (!hideOnboarding) {
      setShowOnboarding(false);
    }
  }, []);

  const handleCloseOnboarding = () => setShowOnboarding(false);



  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(Date.now());
    }, 1000); // Update every second

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    // Fetch the account ID when the component mounts
    const fetchAccountId = async () => {
      try {
        const id = await getAccount();
        setAccountId(id);

        const accountData = await getAccountData(id);
        setBalance(parseFloat(accountData.balance));

        let designs = await getDesignsForAccount(id);

        // Set loading to false and progress to 100 for existing designs
        designs = designs.map(design => ({
          ...design,
          loading: false,
          progress: 100,
        }));

        setUserDesigns(designs);
      } catch (error) {
        console.error('Error fetching account ID:', error);
      } finally {
        // Set isPageLoading to false when fetch is complete
        setIsPageLoading(false);
      }
    };
    fetchAccountId();
  }, []);

  const exampleWorks = [
    {
      "file": "https://files.plugger.ai/2f021d60-b996-47ee-bd96-e26598d1853d.png",
      "execution_data": {
        "prompt": "Best friends should be #breastfriends. Show the love and schedule a mammogram together at MetroHealth."
      }
    },
    {
      "file": "https://files.plugger.ai/b362dc57-716c-4020-8b75-2cdd0ae5fc59.png",
      "execution_data": {
        "prompt": "Best friends should be #breastfriends. Show the love and schedule a mammogram together at MetroHealth."
      }
    },
    {
      "file": "https://tmp.cameralyze.co/857abf25-a878-4acc-a7c4-f8ef8bd641de.png",
      "execution_data": {
        "prompt": "Final Days to Save on Biking Tours: UTracks' 2025 Early Bird Sale ends soon! Now is the time to book your 2025 active trip in Europe: dates released; new trips; and a discount across 300+ tours! Book during the Early Bird Sale and save now. Must end Friday, October 18."
      }
    },
    {
      "file": "https://files.plugger.ai/31bfa31a-9819-4bd0-943e-1c04a444b6af.png?v=1728654535",
      "execution_data": {
        "prompt": "Don't let healthcare costs stress you out! With Just Right Obamacare, finding the perfect plan is fast and easy. We help you compare options and select a policy that works best for your health needs and your wallet. Why settle for less when you can get the best coverage at the right price?"
      }
    },
    {
      "file": "https://files.plugger.ai/fb45f0f3-5f6e-4ee7-ab5e-30f0217691b7.png?v=1728654478",
      "execution_data": {
        "prompt": "Don't let healthcare costs stress you out! With Just Right Obamacare, finding the perfect plan is fast and easy. We help you compare options and select a policy that works best for your health needs and your wallet. Why settle for less when you can get the best coverage at the right price?"
      }
    },
    {
      "file": "https://files.plugger.ai/4b0aafc9-6dc8-4463-a0c7-7cfd0e6a30ec.png?v=1727867937",
      "execution_data": {
        "prompt": "Zapier: Automate without limits\nTurn chaos into smooth operations by automating workflows yourself—no developers, no IT tickets, no delays. The only limit is your imagination."
      }
    },
    {
      "file": "https://files.plugger.ai/ab69aeca-7de8-408c-b536-dd035418dc44.png",
      "execution_data": {
        "prompt": "Ahrefs: Your digital marketing strategy backed by real, actionable data"
      }
    },
    {
      "file": "https://files.plugger.ai/9f06e834-3728-49b1-adc2-e9fff3e58699.png",
      "execution_data": {
        "prompt": "Write Efficient SQL in Seconds\nCreate, optimize, and automate SQL queries - no expert skills needed. Save time and avoid errors with AI.\n\nUse a shocking man in the image"
      }
    },
    {
      "file": "https://files.plugger.ai/40e8249f-134e-41ab-97f1-1b102f383da0.png",
      "execution_data": {
        "prompt": "30% discount on burgers"
      }
    },
    {
      "file": "https://files.plugger.ai/ed9e89ae-397d-4626-9e99-3e52800d2717.png",
      "execution_data": {
        "prompt": "Rent your car now, earn $99 discount!"
      }
    },
    {
      "file": "https://files.plugger.ai/015ce722-fd52-4c48-80bd-bb67dfce768b.png?v=1727861444",
      "execution_data": {
        "prompt": "Rent your car now, earn $99 discount!\n\nUse a Mercedes car in the image."
      }
    },
    {
      "file": "https://files.plugger.ai/383052c0-fb4e-49b0-a8cb-19b349dabce6.png?v=1727871220",
      "execution_data": {
        "prompt": "Bluedot: Seamless Charging and Management for\nYour EV Fleet Access over 80% of chargers in the US. Manage and track your fleet wherever it goes."
      }
    },
    {
      "file": "https://files.plugger.ai/51d11cc1-4ff1-4570-86ef-c034719fd094.png?v=1727871008",
      "execution_data": {
        "prompt": "Bluedot: Seamless Charging and Management for\nYour EV Fleet Access over 80% of chargers in the US. Manage and track your fleet wherever it goes."
      }
    }
  ]

  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    700: 2,
    500: 1
  };

  const handlePay = async () => {
    setPaymentLinkLoading(true);
    let amountToAdd = selectedAmount;
    if (selectedAmount === 'custom') {
      amountToAdd = parseInt(customAmount, 10);
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'balance',
      amount: amountToAdd
    });

    if (amountToAdd && amountToAdd >= 10) {
      const paymentLink = await pay({ quantity: amountToAdd });
      window.location.href = paymentLink.url;
      setShowAddBalanceModal(false);
    } else {
      alert('Please enter a valid amount greater than $10.');
    }
  };

  const handleGenerate = async () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'generator',
      prompt: prompt,
      imagePrompt: imagePrompt,
      size: aspectRatio,
      substyle: bannerStyle,
    });

    setIsGenerating(true);
    const totalCost = imageBannerPrice * numberOfImages;

    if (balance < totalCost) {
      setShowAddBalanceModal(true);
      return;
    }

    try {
      const placeholders = Array.from({ length: numberOfImages }, (_, idx) => ({
        id: `placeholder-${Date.now()}-${idx}-${Math.random()}`,
        prompt: prompt,
        imagePrompt: imagePrompt,
        size: aspectRatio,
        substyle: bannerStyle,
        imageUrl: null,
        loading: true,
        startTime: Date.now(),
      }));

      setUserDesigns(prevDesigns => [...placeholders, ...prevDesigns]);

      const designRequest = await generate({
        prompt: prompt,
        image_prompt: imagePrompt,
        size: aspectRatio,
        quantity: numberOfImages,
        substyle: bannerStyle,
      });

      placeholders.forEach((placeholder, idx) => {
        const designId = placeholder.id;

        (async () => {
          try {
            const imageData = designRequest[idx];

            if (imageData.image_url) {
              // Deduct balance only if image_url is present
              const newBalance = await deductFromAccountBalance(accountId, imageBannerPrice);
              setBalance(newBalance);

              setUserDesigns(prevDesigns =>
                prevDesigns.map(design =>
                  design.id === designId
                    ? {
                      ...design,
                      imageUrl: imageData.image_url,
                      loading: false,
                    }
                    : design
                )
              );

              if (accountId) {
                await saveDesign({
                  accountId: accountId,
                  prompt: prompt,
                  imagePrompt: imagePrompt,
                  size: aspectRatio,
                  substyle: bannerStyle,
                  imageUrl: imageData.image_url,
                });
                console.log(`Design ${idx + 1} saved successfully.`);
              } else {
                console.error('Account ID is not available.');
              }
            }
          } catch (error) {
            console.error('Error generating or saving image:', error);

            setUserDesigns(prevDesigns =>
              prevDesigns.map(design =>
                design.id === designId
                  ? {
                    ...design,
                    loading: false,
                    error: true,
                  }
                  : design
              )
            );
          }
        })();
      });
    } catch (error) {
      console.error('Error in handleGenerate:', error);
    } finally {
      setIsGenerating(false); // Re-enable the button after the function completes
    }
  };

  return (
    <div>
      <HeaderMenu />
      <Container fluid>
        <OnboardingModal show={showOnboarding} handleClose={handleCloseOnboarding} />
        <Row>
          <Col xs={12} md={4} className="p-3">
            <div className="border rounded shadow p-3 mb-4 d-flex justify-content-between align-items-center">
              <div className='d-flex flex-column align-items-start justify-content-start'>
                <span><strong>Balance: </strong></span><span>${balance.toFixed(2)}</span>
              </div>
              <Button size='sm' className='brand-button' onClick={() => setShowAddBalanceModal(true)}>
                <IoAdd className="me-1" /> Add Balance
              </Button>
            </div>

            {/* Left Side Content */}
            <div className="left-content">

              <Form>
                <Form.Group controlId="promptInput" className='mb-4'>
                  <Form.Label>Banner Content</Form.Label>
                  <Form.Control
                    as="textarea" // Changed from "text" to "textarea"
                    placeholder="30% discount on burgers"
                    value={prompt}
                    onChange={(e) => setPrompt(e.target.value)}
                    rows={5} // Optional: Set the number of rows for the textarea
                  />
                </Form.Group>

                <Form.Group controlId="promptInput" className='mb-4'>
                  <Form.Label>Image Prompt</Form.Label>
                  <Form.Control
                    as="textarea"
                    placeholder="A delicous burger"
                    value={imagePrompt} // Use imagePrompt state
                    onChange={(e) => setImagePrompt(e.target.value)} // Update imagePrompt state
                    rows={5}
                  />
                  <div className="d-flex justify-content-end mt-1">
                    <Button variant="outline-secondary" className="custom-small-button me-1">
                      <IoCloudUpload className="me-1" /> {/* Add the icon here */}
                      Upload Image
                    </Button>
                  </div>
                </Form.Group>

                <Form.Group controlId="bannerStyleSelect" className='mb-4'>
                  <Form.Label>Banner Style</Form.Label>
                  <div className="d-flex justify-content-start">
                    <Button
                      variant="outline"
                      onClick={() => setBannerStyle('Classic')}
                      className={`d-flex flex-column align-items-center me-1 p-0 ${bannerStyle === 'Classic' ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <img
                        src="https://tmp.cameralyze.co/ff336a5d-0dae-43b8-b86a-9c9b3f0bec0e.png"
                        alt="Classic"
                        className="img-fluid"
                        style={{ width: '100px', height: '100px' }}
                      />
                      <span className="small-text mt-1">Classic</span>
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => setBannerStyle('Elegant')}
                      className={`d-flex flex-column align-items-center p-0 ${bannerStyle === 'Elegant' ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <img
                        src="https://files.plugger.ai/fe74af1e-4214-46b4-9729-9eb3948c139c.png"
                        alt="Elegant"
                        className="img-fluid"
                        style={{ width: '100px', height: '100px' }}
                      />
                      <span className="small-text mt-1">Elegant</span>
                    </Button>
                  </div>
                </Form.Group>


                <Form.Group controlId="aspectRatioSelect" className='mb-4'>
                  <Form.Label>Banner Size</Form.Label>
                  <div className="d-flex justify-content-start">
                    <Button
                      variant="outline"
                      onClick={() => setAspectRatio('1:1')}
                      className={`d-flex flex-column align-items-center me-1 ${aspectRatio === '1:1' ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <IoSquareOutline className='display-6' />
                      <span className="small-text mt-1">1:1</span>
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => setAspectRatio('16:9')}
                      className={`d-flex flex-column align-items-center me-1 ${aspectRatio === '16:9' ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <IoTabletLandscapeOutline className='display-6' />
                      <span className="small-text mt-1">16:9</span>
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => setAspectRatio('9:16')}
                      className={`d-flex flex-column align-items-center ${aspectRatio === '9:16' ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <IoTabletPortraitOutline className='display-6' />
                      <span className="small-text mt-1">9:16</span>
                    </Button>
                  </div>
                </Form.Group>

                <Form.Group controlId="numberOfImagesSelect" className='mb-4'>
                  <Form.Label>Banner Quantity</Form.Label>
                  <div className="d-flex justify-content-start">
                    <Button
                      variant="outline"
                      onClick={() => setNumberOfImages(1)}
                      className={`d-flex flex-column align-items-center me-1 ${numberOfImages === 1 ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <span className="small-text mt-1">1</span>
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => setNumberOfImages(2)}
                      className={`d-flex flex-column align-items-center me-1 ${numberOfImages === 2 ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <span className="small-text mt-1">2</span>
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => setNumberOfImages(3)}
                      className={`d-flex flex-column align-items-center me-1 ${numberOfImages === 3 ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <span className="small-text mt-1">3</span>
                    </Button>
                    <Button
                      variant="outline"
                      onClick={() => setNumberOfImages(4)}
                      className={`d-flex flex-column align-items-center ${numberOfImages === 4 ? 'selected-button' : 'type-selection-button'}`}
                    >
                      <span className="small-text mt-1">4</span>
                    </Button>
                  </div>
                </Form.Group>

                <Button variant="outline-dark" onClick={handleGenerate} className="w-100" disabled={isGenerating}>
                  Generate
                </Button>
                <small className="text-muted font-small d-block mt-2">
                  Cost: ${(imageBannerPrice * numberOfImages).toFixed(2)} - Cost of the per design is ${imageBannerPrice}
                </small>
              </Form>
            </div>
          </Col>
          <Col xs={12} md={8} className="p-3 right-content">
            {isPageLoading ? (
              // Display loading spinner and text
              <div className="d-flex flex-column align-items-center justify-content-center h-100">
                <Spinner animation="border" role="status" variant="primary">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
                <p className="mt-3 text-primary">Loading your designs...</p>
              </div>
            ) : userDesigns.length > 0 ? (
              <Masonry
                breakpointCols={breakpointColumnsObj}
                className="my-masonry-grid"
                columnClassName="my-masonry-grid_column"
              >
                {userDesigns.map((design, index) => (
                  <div key={design.id || index} className="mb-3 position-relative shadow-8">
                    {design.loading ? (
                      <div className="loading-card d-flex flex-column align-items-center justify-content-center shadow">
                        <FaImage className="loading-icon mb-3 mt-3" size={48} color="#888" />
                        {(() => {
                          const totalTime = 90000; // 90 seconds in milliseconds
                          const elapsedTime = currentTime - design.startTime;
                          const progress = Math.min((elapsedTime / totalTime) * 100, 99); // Cap at 99%
                          return (
                            <ProgressBar
                              now={progress}
                              label={`${Math.round(progress)}%`}
                              className="w-75 mb-3"
                            />
                          );
                        })()}
                      </div>
                    ) : design.error ? (
                      // ... existing error handling
                      <div className="error-card d-flex flex-column align-items-center justify-content-center shadow">
                        <FaImage className="error-icon mb-3 mt-3" size={48} color="red" />
                        <p className="text-danger">Failed to load image</p>
                      </div>
                    ) : (
                      <img
                        src={design.imageUrl}
                        alt={`Design ${index}`}
                        className="img-fluid rounded shadow-8"
                      />
                    )}
                    {!design.loading && !design.error && (
                      <div
                        className="overlay d-flex justify-content-center align-items-center"
                        onMouseEnter={(e) => e.currentTarget.classList.add('active')}
                        onMouseLeave={(e) => e.currentTarget.classList.remove('active')}
                      >
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            if (design.prompt) {
                              setPrompt(design.prompt);
                            }
                            if (design.imagePrompt) {
                              setImagePrompt(design.imagePrompt);
                            }
                          }}
                        >
                          Generate
                        </button>
                      </div>
                    )}
                  </div>
                ))}
              </Masonry>
            ) : (
              // If no user designs, show example works
              <>
                {balance === 0 && (
                  <div className="campaign-card mb-4 p-3 border rounded shadow border-black">
                    <h5>November Opportunity</h5>
                    <ul className="list-unstyled pt-2">
                      <li className="d-flex align-items-center mb-2">
                        <span className="text-success me-2 d-flex align-items-center">
                          <IoCheckmarkCircle /> {/* React Icons */}
                        </span>
                        Earn 2x for every loaded balance this November.
                      </li>
                      <li className="d-flex align-items-center">
                        <span className="text-success me-2 d-flex align-items-center">
                          <IoCheckmarkCircle />
                        </span>
                        No monthly commitment, only pay as you go!
                      </li>
                    </ul>
                    <div className="d-flex justify-content-end">
                      <Button size='sm' className='brand-button' onClick={() => setShowAddBalanceModal(true)}>
                        <IoAdd className="me-1" /> Add Balance
                      </Button>
                    </div>
                  </div>
                )}

                <Masonry
                  breakpointCols={breakpointColumnsObj}
                  className="my-masonry-grid"
                  columnClassName="my-masonry-grid_column"
                >
                  {exampleWorks.map((item, index) => (
                    <div key={index} className="mb-3 position-relative shadow-8">
                      <img
                        src={item.file}
                        alt={`Example ${index}`}
                        className="img-fluid rounded shadow-8"
                      />
                      <div
                        className="overlay d-flex justify-content-center align-items-center"
                        onMouseEnter={(e) => e.currentTarget.classList.add('active')}
                        onMouseLeave={(e) => e.currentTarget.classList.remove('active')}
                      >
                        <button
                          className="btn btn-primary"
                          onClick={() => {
                            if (item.execution_data && item.execution_data.prompt) {
                              setPrompt(item.execution_data.prompt);
                            }
                          }}
                        >
                          Generate
                        </button>
                      </div>
                    </div>
                  ))}
                </Masonry>
              </>
            )}
          </Col>
          <Modal show={showAddBalanceModal} onHide={() => setShowAddBalanceModal(false)}>
            <Modal.Header closeButton>
              <Modal.Title>Add Balance</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="campaign-card mb-4 p-3 border rounded shadow">
                <h5>November Opportunity</h5>
                <ul className="list-unstyled pt-2">
                  <li className="d-flex align-items-center mb-2">
                    <span className="text-success me-2 d-flex align-items-center">
                      <IoCheckmarkCircle /> {/* React Icons */}
                    </span>
                    Earn 2x for every loaded balance this November.
                  </li>
                  <li className="d-flex align-items-center">
                    <span className="text-success me-2 d-flex align-items-center">
                      <IoCheckmarkCircle />
                    </span>
                    No monthly commitment, only pay as you go!
                  </li>
                </ul>
              </div>
              <div className="d-flex flex-wrap mb-3">
                {[10, 20, 50, 100].map(amount => (
                  <Button
                    key={amount}
                    variant={selectedAmount === amount ? 'dark' : 'outline-dark'}
                    className="m-1"
                    onClick={() => {
                      setSelectedAmount(amount);
                      setCustomAmount('');
                    }}
                  >
                    ${amount}
                  </Button>
                ))}
                <Button
                  variant={selectedAmount === 'custom' ? 'dark' : 'outline-dark'}
                  className="m-1"
                  onClick={() => setSelectedAmount('custom')}
                >
                  Custom
                </Button>
              </div>
              {selectedAmount === 'custom' && (
                <Form.Group controlId="customAmountInput">
                  <Form.Label>Custom Amount (more than $10)</Form.Label>
                  <Form.Control
                    type="number"
                    min="11"
                    value={customAmount}
                    onChange={(e) => setCustomAmount(e.target.value)}
                    placeholder="Enter amount"
                  />
                </Form.Group>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button className='brand-button' onClick={handlePay} disabled={paymentLinkLoading}>
                {paymentLinkLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                ) : null}
                Pay
              </Button>
            </Modal.Footer>
          </Modal>

        </Row>
      </Container>
    </div>
  );
};

export default GeneratorPage;